import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/FiberElements/Logo';
import { checkEmailInContract } from '../hooks/useBlockchain';
import ConnectWallet from '../components/Buttons/ConnectWallet';

const RegistrationComponent = ({ web3Handler, account }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isVerified, setIsVerified] = useState(false); // Correo verificado on-chain
  const [isFormSent, setIsFormSent] = useState(false); // Correo enviado al Google Form
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Acceso - Nuestra Plataforma";
    if (account && isVerified && isFormSent) {
      navigate('/course/profile');
    }
  }, [account, isVerified, isFormSent, navigate]);

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setError(emailRegex.test(value) ? '' : 'Correo inválido');
  };

  const verifyEmail = async (e) => {
    e.preventDefault();
    if (!error) {
      try {
        const { /* wallet, contractFound, */ found } = await checkEmailInContract(email);
        if (found) {
          setIsVerified(true);
          console.log("Correo verificado on-chain");
        } else {
          alert("Correo no encontrado en la blockchain.");
        }
      } catch (err) {
        console.error('Error en la verificación:', err);
      }
    }
  };

  const submitToGoogleForm = () => {
    const formFieldName = 'entry.1612089965';
    const googleFormURL = 'https://docs.google.com/forms/d/e/1FAIpQLSf_If1yAJB3vkVSAiKY81SAmtQ0twfgkKGJVB3sL7lWtYSSxA/formResponse';

    let iframe = document.getElementById('hidden_iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.name = 'hidden_iframe';
      iframe.id = 'hidden_iframe';
      document.body.appendChild(iframe);
    }

    const form = document.createElement('form');
    form.style.display = 'none';
    form.setAttribute('method', 'POST');
    form.setAttribute('action', googleFormURL);
    form.setAttribute('target', 'hidden_iframe');

    const input = document.createElement('input');
    input.setAttribute('name', formFieldName);
    input.setAttribute('value', email);
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    console.log('Correo enviado a Google Forms vía formulario oculto');
    setIsFormSent(true);
  };

  return (
    <div className="serif-root"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        color: 'white'
      }}
    >
      {/* Tipografía serif aplicada a todo el componente */}
      <style>{`
        .serif-root, .serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: 0.01em;
        }
      `}</style>

      <div
        style={{
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(20px)',
          padding: '20px',
          borderRadius: '10px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          width: '300px',
          textAlign: 'center',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }}
      >
        <div style={{ width: '150px', height: '150px', margin: '0 auto' }}>
          <Logo />
        </div>

        {!isVerified && (
          <form onSubmit={verifyEmail} style={{ marginTop: '20px' }}>
            <label style={{ marginBottom: '10px', display: 'block', color: 'black' }}>
              <strong>Correo Electrónico:</strong>
            </label>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="Correo electrónico"
              required
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: '1px solid rgba(255, 255, 255, 0.5)',
                background: 'rgba(255, 252, 252, 0.6)',
                color: 'black',
                width: '100%',
                outline: 'none',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                transition: 'all 0.3s ease',
              }}
            />
            {error && <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{error}</p>}
            <button
              type="submit"
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: 'none',
                backgroundColor: '#D6AF44',
                color: 'black',
                fontWeight: 'bold',
                cursor: 'pointer',
                width: '100%',
                marginTop: '10px'
              }}
              disabled={!!error}
            >
              Verificar Email
            </button>
          </form>
        )}

        {isVerified && !isFormSent && (
          <div style={{ marginTop: '20px' }}>
            <p style={{ color: 'green' }}>El correo se verificó con éxito.</p>
            <button
              onClick={submitToGoogleForm}
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: 'none',
                backgroundColor: '#D6AF44',
                color: 'black',
                fontWeight: 'bold',
                cursor: 'pointer',
                width: '100%',
                marginTop: '10px'
              }}
            >
              Enviar Correo
            </button>
          </div>
        )}

        {isVerified && isFormSent && (
          <>
            <p style={{ color: 'green', marginTop: '10px' }}>Correo registrado correctamente.</p>
            <p style={{ color: 'green', marginTop: '10px' }}>Conectar Wallet:</p>
            <ConnectWallet web3Handler={web3Handler} account={account} />
          </>
        )}
      </div>
    </div>
  );
};

export default RegistrationComponent;
